module.exports = __webpack_public_path__ + "static/media/babyname.6604b583.png";